<template>
  <el-card class="card-horizontal" v-loading="isLoading">
    <a v-bind="{ class: locked ? null : 'module__link' }" v-on="locked ? {} : { click: enrollAndStartCourse }">
      <el-row :gutter="20">
        <el-col :xs="{ span: 12, offset: 6 }" :sm="8" :md="4">
          <div class="card-horizontal__media">
            <img v-if="course.bigImage" :src="course.bigImage">
            <img v-else :src="fallbackJpg">
          </div>
        </el-col>
        <el-col :xs="24" :sm="16" :md="20">
          <header class="card-horizontal__header">
            <h4 class="h4 font-family-body">{{ course.title }}</h4>
            <div v-if="course.fullLine">
              <img :src="fullLineRibbon" />
              <span class="full-line-title">
                {{ course.fullLine }}
              </span>
            </div>
            <h4 class="h6 font-family-body">{{ course.description }}</h4>
          </header>
          <div class="card-horizontal__actions">
            <span v-if="locked" class="card-horizontal__link-locked">{{ $t('trainingModuleCardEnrollCta')
            }}&nbsp;&nbsp;<img :src="lockImage" /></span>
            <span v-else-if="course.isFullLineSummary" class="card-horizontal__link-emphasized">{{
                $t('trainingModuleSummaryCardCta')
            }}</span>
            <span v-else class="card-horizontal__link-emphasized">{{ $t('trainingModuleCardCta') }}</span>
          </div>
        </el-col>
      </el-row>
    </a>
  </el-card>
</template>

<script>
import fallbackJpg from '@/assets/images/fallbackSquare.jpg';
import api from '@/api';
import router from '@/router';
import lockImage from '@/assets/images/lock.svg';
import fullLineRibbon from '@/assets/images/full-line-ribbon.svg';
import loadingStateReset from '@/mixins/loadingStateReset';

export default {
  name: 'TrainingAvailableCard',
  mixins: [loadingStateReset],
  data() {
    return {
      fallbackJpg,
      lockImage,
      isLoading: false,
      fullLineRibbon,
    }
  },
  props: {
    course: Object,
    locked: Boolean,
  },
  methods: {
    enrollAndStartCourse: function (event) {
      this.isLoading = true;
      api.get('/actions/mercury/talent-lms/enroll?course=' + this.course.id)
        .then(function (response) {
          window.location.href = response.url;
        })
        .catch(function (error) {
          log.error(error);
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';

.module {

  &__link {
    overflow: hidden;
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
    text-decoration: none;
  }
}

.card-horizontal {
  &__link-locked::after {
    content: none;
  }

  .card-horizontal__media {
    @include res(xs) {
      margin-bottom: 30px;
    }

    img {
      object-position: bottom;
      object-fit: contain;
    }
  }
}

.full-line-title {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  color: #D31F25;
  text-transform: uppercase;
  vertical-align: text-top;
}
</style>